export default __webpack_public_path__ + "assets/images/cross-4d7e9850452da54f19f5bac889800433.svg";